import { render, staticRenderFns } from "./DetailLayoutWrapper.vue?vue&type=template&id=19433a0f&scoped=true&"
import script from "./DetailLayoutWrapper.vue?vue&type=script&lang=ts&"
export * from "./DetailLayoutWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./DetailLayoutWrapper.vue?vue&type=style&index=0&id=19433a0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19433a0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
